import CircularProgress from "@mui/material/CircularProgress";
import type { ReactNode } from "react";
import { gaps } from "../../spacing";
import { Subtitle } from "../../data-display/Subtitle";
import { CenteredStack } from "../../layout/CenteredStack";

interface LoadingStateProps {
  label?: ReactNode;
  minHeight?: number | string;
}

/** Centered spinner with an optional label, for in-progress page or section states. */
export function LoadingState({ label, minHeight = 240 }: LoadingStateProps) {
  return (
    <CenteredStack gap={gaps.base} $minHeight={minHeight}>
      <CircularProgress />
      {label ? <Subtitle>{label}</Subtitle> : null}
    </CenteredStack>
  );
}
